// GENERAL VISIBILITY

export const TOGGLE_SIDEBAR = 'APP/TOGGLE_SIDEBAR';

// AUTHENTICATION

export const AUTHENTICATION_ATTEMPT = 'AUTH/AUTHENTICATION_ATTEMPT';
export const AUTHENTICATION_SUCCESS = 'AUTH/AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_FAILURE = 'AUTH/AUTHENTICATION_FAILURE';

export const LOG_OUT = 'AUTH/LOG_OUT';

// USERS

export const FIND_USERS_ATTEMPT = 'USERS/FIND_ATTEMPT';
export const FIND_USERS_SUCCESS = 'USERS/FIND_SUCCESS';
export const FIND_USERS_FAILURE = 'USERS/FIND_FAILURE';

export const REMOVE_USER_ATTEMPT = 'USERS/REMOVE_ATTEMPT';
export const REMOVE_USER_SUCCESS = 'USERS/REMOVE_SUCCESS';
export const REMOVE_USER_FAILURE = 'USERS/REMOVE_FAILURE';

export const UPSERT_USER_ATTEMPT = 'USERS/UPSERT_ATTEMPT';
export const UPSERT_USER_SUCCESS = 'USERS/UPSERT_SUCCESS';
export const UPSERT_USER_FAILURE = 'USERS/UPSERT_FAILURE';

export const TOGGLE_USER_UPSERT_MODAL = 'USERS/TOGGLE_UPSERT_MODAL';
export const TOGGLE_USER_FILTERS_MODAL = 'USERS/TOGGLE_FILTERS_MODAL';

export const SET_USERS_FILTER = 'USERS/SET_FILTER';

export const SELECT_USER = 'USERS/SELECT_USER';

export const CHANGE_USER_FORM_VALUE = 'USERS/CHANGE_FORM_VALUE';
export const RESET_USER_FORM = 'USERS/RESET_FORM';
export const FILL_USER_FORM = 'USERS/FILL_FORM';

// PERSONAS

export const FIND_PERSONAS_ATTEMPT = 'PERSONAS/FIND_ATTEMPT';
export const FIND_PERSONAS_SUCCESS = 'PERSONAS/FIND_SUCCESS';
export const FIND_PERSONAS_FAILURE = 'PERSONAS/FIND_FAILURE';

export const TOGGLE_PERSONA_UPSERT_MODAL = 'PERSONAS/TOGGLE_UPSERT_MODAL';

export const UPSERT_PERSONA_ATTEMPT = 'PERSONAS/UPSERT_ATTEMPT';
export const UPSERT_PERSONA_SUCCESS = 'PERSONAS/UPSERT_SUCCESS';
export const UPSERT_PERSONA_FAILURE = 'PERSONAS/UPSERT_FAILURE';

export const CHANGE_PERSONA_FORM_VALUE = 'PERSONAS/CHANGE_FORM_VALUE';
export const RESET_PERSONA_FORM = 'PERSONAS/RESET_FORM';

export const PERSONA_VALIDATION_ERROR = 'PERSONAS/VALIDATION_ERROR';


// WEBPACK FOOTER //
// ./client/store/actions/constants.js